import {DrawLineCheckpointInterface} from '@modules/activities/core/models/draw-line-checkpoint.interface';

export interface DrawLineStepInterface {
    imagePath: string;
    checkpoints: DrawLineCheckpointInterface[];
    validColors: string[];
}